import { ICommandBase } from '@Alternatives/cqrs';
import { FormDeleterDialogViewModel } from "@Alternatives/Forms/Components/FormDeleterDialog";
import FormDeleterDialog from '@Alternatives/Forms/Components/FormDeleterDialog.vue';
import { FormDependenciesDialogViewModel } from "@Alternatives/Forms/Components/FormDependenciesDialog";
import FormDependenciesDialog from '@Alternatives/Forms/Components/FormDependenciesDialog.vue';
import { FormEditorSaveEventPayload, FormEditorViewModel } from "@Alternatives/Forms/Components/FormEditor";
import FormEditor from "@Alternatives/Forms/Components/FormEditor.vue";
import { CreateFormCommandV1, DeleteFormCommandV1, RenameFormCommandV1 } from '@Alternatives/Forms/Domain/commands-core';
import FormsCommands from '@Alternatives/Forms/Domain/commands-vue-component';
import FormsQueries from '@Alternatives/Forms/Domain/queries-vue-component';
import { FormDefDependenciesReadModel, FormReadModel, FormsPageReadModel } from '@Alternatives/Forms/Domain/readmodels';
import { dateCompare1, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { ICommandStatus } from "@cqrs/cqrs";
import moment from "moment";
import { Component, mixins } from 'vue-facing-decorator';
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';


@Component({
    components: {
        PortfolioOrDecisionNavigation, FormDeleterDialog, FormDependenciesDialog, FormEditor
    }
})
export default class FormsPage extends mixins(FormsQueries, FormsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

    rm: FormsPageReadModel = null;
    SearchPhrase: string = null;
    OrderBy: string = "modified";
    OrderByDescending: boolean = true;

    formDeleterDialog: FormDeleterDialogViewModel = new FormDeleterDialogViewModel();
    formEditor: FormEditorViewModel = new FormEditorViewModel();
    formDependenciesDialog: FormDependenciesDialogViewModel = new FormDependenciesDialogViewModel();

    get formsView()
    {
        let view = new Array(...this.rm.Forms);

        if (this.SearchPhrase)
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.OrderBy === "name")
        {
            view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }
        else if (this.OrderBy === "modified")
        {
            view = view.sort((a, b) => dateCompare1(a.Modified, b.Modified));
        }
        else if (this.OrderBy === "created")
        {
            view = view.sort((a, b) => dateCompare1(a.Created, b.Created));
        }

        if (this.OrderByDescending === true)
        {
            view = view.reverse();
        }

        return view;
    }

    url_EditFormPage(formId: number)
    {
        return dynamicUiRoutes.Alternatives_EditFormPage(this.$route, this.workspaceId, this.projectId, formId);
    }

    getFormattedDateStr(date: string): string 
    {
        return moment(date).format('MMM D, YYYY');
    }

    getFormattedTimeStr(date: string): string 
    {
        return moment(date).format('LT');
    }

    orderByName()
    {
        if (this.OrderBy === 'name')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = false;
            this.OrderBy = 'name';
        }
    }

    orderByModified()
    {
        if (this.OrderBy === 'modified')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'modified';
        }
    }

    orderByCreated()
    {
        if (this.OrderBy === 'created')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'created';
        }
    }


    showFormCreator()
    {
        this.formEditor.showCreator();
    }

    showFormEditor(f: FormReadModel)
    {
        this.formEditor.showEditor(f.Id, f.Name);
    }

    showFormCloner(f: FormReadModel)
    {
        this.formEditor.showCloner(f.Id, f.Name);
    }

    showFormDeleter(f: FormReadModel)
    {
        this.formDeleterDialog.show(f.Id, f.Name);
        this.runFormDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, f.Id);
    }

    showFormDependenciesViewer(f: FormReadModel)
    {
        this.formDependenciesDialog.show(f.Id, f.Name);
        this.runFormDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, f.Id);
    }


    handleFormEditorSave(e: FormEditorSaveEventPayload)
    {
        if (e.id === 0)
        {
            this.invokeCreateFormCommandV1(this.workspaceId, this.projectId, e.id, e.name, e.sourceId);
        }
        else
        {
            this.invokeRenameFormCommandV1(this.workspaceId, this.projectId, e.id, e.name);
        }
    }

    handleDeleteFormCommand(formId: number)
    {
        this.invokeDeleteFormCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, formId);
    }

    mounted()
    {
        document.title = "Forms | TransparentChoice";
        this.runFormsPageQueryV1(this.workspaceId, this.projectId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "FormsPageReadModel")
        {
            this.rm = model as FormsPageReadModel;
        }
        else if (modelName == "FormReadModel")
        {
            const rm = model as FormReadModel;
            this.rm.Forms = this.rm.Forms.filter(a => a.Id !== rm.Id);
            this.rm.Forms.push(rm);
        }
        else if (modelName == "FormDefDependenciesReadModel")
        {
            const rm = model as FormDefDependenciesReadModel;
            this.formDeleterDialog.setData(rm);
            this.formDependenciesDialog.setData(rm);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (CreateFormCommandV1.matchType(cmd))
        {
            //this.runFormByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, Number(result));
            this.formEditor.close();

            const formId = Number(result);
            window.location.href = this.url_EditFormPage(formId);
        }
        else if (RenameFormCommandV1.matchType(cmd))
        {
            this.runFormByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, Number(correlationId));

            this.formEditor.close();
        }
        else if (DeleteFormCommandV1.matchType(cmd))
        {
            const formId = Number(correlationId);
            this.rm.Forms = this.rm.Forms.filter(a => a.Id !== formId);

            this.formDeleterDialog.close();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateFormCommandV1.matchType(status.Command))
        {
            this.formEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (RenameFormCommandV1.matchType(status.Command))
        {
            this.formEditor.displayValidationErrors(status.ValidationErrors);
        }
    }
}